import { Box } from "@mui/material"
import { useState } from "react"
import { Button, Form } from "react-bootstrap"
import TextInput from "../../components/ReactHookForm/TextInput"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { multadoSchema, onSubmitSavePersonaMultada } from "./handlers"
import MuniSpinner from "../../components/MuniSpinner"

const FormEditarPersonaMultada = ({ setModalEditarInfoIsOpen, personaMultada, idActa, setActa }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, formState: { errors, dirtyFields }, } = useForm({
    resolver: yupResolver(multadoSchema),
    defaultValues: {
      id_acta: idActa,
      nombre: personaMultada.nombre,
      apellido: personaMultada.apellido,
      numero_de_documento: personaMultada.numero_de_documento,
      direccion: personaMultada.direccion,
      provincia: personaMultada.provincia,
      localidad: personaMultada.localidad,
    }
  })

  return (
    <Box>
      <>
        <Form onSubmit={handleSubmit((data) => onSubmitSavePersonaMultada(data, setIsLoading, setModalEditarInfoIsOpen, setActa))}>
          <fieldset disabled={isLoading}>
            <div className="d-none">
              <TextInput name='id_acta' label='ID Acta *' register={register} disabled />
            </div>
            <TextInput name='nombre' label='Nombres *' register={register} errors={errors?.nombre} disabled />
            <TextInput name='apellido' label='Apellidos *' register={register} errors={errors?.apellido} disabled />
            <TextInput name='numero_de_documento' label='DNI *' register={register} errors={errors?.numero_de_documento} disabled />
            <TextInput name='direccion' label='Direccion *' register={register} errors={errors?.direccion} />
            <TextInput name='localidad' label='Localidad *' register={register} errors={errors?.localidad} />
            <TextInput name='provincia' label='Provincia *' register={register} errors={errors?.provincia} />
            <Box className="d-flex justify-content-start mt-3">
              {!isLoading ? (
                <Box className='d-flex flex-wrap gap-2'>
                  <Button type="submit" disabled={Object.keys(dirtyFields).length === 0}>
                    Guardar
                  </Button>
                  <Button variant='danger' onClick={() => setModalEditarInfoIsOpen(false)}>
                    Cancelar
                  </Button>
                </ Box>
              ) :
                <div className="w-100">
                  <MuniSpinner />
                </div>
              }
            </Box>
          </fieldset>
        </Form>
      </>
    </Box>
  )
}

export default FormEditarPersonaMultada